import {$document} from "./globals";
import {cModal} from "./c-modal-new";
import {translate} from "./language";
import {FastMessage} from "./fastmessages-new";

$document.on('click', '[data-jquery=addProductToComparator]', function (e) {
    e.preventDefault();
    const id_product = $(this).attr('data-product-id');
    $('#comparator-box').removeClass('u-none')
    ProductComparator.addToComparator(id_product, this);
});
$document.on('click', '.c-compare .text', function () {
    $(this).prev().trigger('click');
});
$document.on('click', '[data-jquery=removeProductFromComparator]', function (e) {
    e.preventDefault();
    const id_product = $(this).attr('data-product-id');
    if ($('#comparator-count').attr('data-count') === 0) {
        $('#comparator-box').addClass('u-none')
    }
    ProductComparator.removeFromComparator(id_product);
});
$document.on('click', '[data-jquery=clearProductComparator]', function (e) {
    e.preventDefault();
    $('#comparator-box').addClass('u-none');
    var reload_page = $(this).attr('data-reload') === '1';
    ProductComparator.clearComparator(reload_page);
});

export class ProductComparator {
    static addToComparator(id_product, element) {
        const comparator_link = $('.c-comparator .count');
        $.ajax({
            url: ProductComparatorPresenter + 'add-product-to-comparator/?id_product=' + id_product,
            dataType: 'json',
            success: function (data) {
                if (typeof data.error != 'undefined') {
                    FastMessage.createMessage(data.error, FastMessage.warning);
                } else {
                    // pridani
                    element.classList.add('favourited');
                    const count = data.count;
                    comparator_link.attr('data-count', count);
                    comparator_link.html(count);
                    if (count > 0) {
                        comparator_link.parent().removeClass('u-none');
                    }
                    cModal.element.find('.c-modal__head').addClass('u-text-center');
                    cModal.element.one('cis.modal.close', function (e) {
                        e._this.element.find('.c-modal__head').removeClass('u-text-center');
                    });
                    cModal.open(translate('Produkt byl přidán do porovnávání.'), data.dialog);
                }
            }
        });
    }

    static removeFromComparator(id_product) {
        const comparator_link = $('.c-comparator .count');
        const comparator_table = $("table.comparatorTable");
        const comparator_table_rows = $("table.comparatorTable tr");
        $.ajax({
            url: ProductComparatorPresenter + 'remove-product-from-comparator/?id_product=' + id_product,
            dataType: 'json',
            success: function (data) {
                if (typeof data.error != 'undefined') {
                    alert(data.error);
                } else {
                    // odebrani
                    FastMessage.createMessage(translate('Produkt byl odebrán z porovnávání'), FastMessage.warning);
                    const count = data.count;
                    comparator_link.attr('data-count', count);
                    comparator_link.html(count);
                    comparator_table_rows.find("td[data-filter=" + id_product + "]").remove();
                    if (count === 0) {
                        comparator_link.parent().addClass('u-none');
                        comparator_table.parent().hide();
                        $(".comparatorNotProducts").removeClass('u-none');
                    }
                }

            }
        });
    }

    static clearComparator(reload_page) {
        const comparator_link = $('.c-comparator .count');
        const comparator_table = $("table.comparatorTable");
        const comparator_table_rows = $("table.comparatorTable tr");
        $.ajax({
            url: ProductComparatorPresenter + 'clear-product-comparator/',
            dataType: 'json',
            success: function (data) {
                if (typeof data.success != 'undefined') {
                    //je to OK
                    const items = document.querySelectorAll('[data-jquery="addProductToComparator"]');
                    for (let i = 0; i < items.length; i++) {
                        items[i].classList.remove('favourited');
                    }
                    const count = 0;
                    comparator_link.attr('data-count', count);
                    comparator_link.html(count);
                    if (typeof data.ids != 'undefined' && data.ids.length) {
                        for (let i = 0; i < data.ids.length; i++) {
                            comparator_table_rows.find(`td[data-filter="${data.ids[i]}"]`).remove();
                        }
                    }
                    comparator_link.parent().addClass('none');
                    comparator_table.hide();
                    $(".comparatorNotProducts").show();
                    if (reload_page) {
                        location.href = CatalogPresenter;
                    }
                } else {
                    alert(data);
                }
            }
        });
    }
}